import { render, staticRenderFns } from "./InformHerMasters.vue?vue&type=template&id=058836b0&scoped=true&"
import script from "./InformHerMasters.vue?vue&type=script&lang=js&"
export * from "./InformHerMasters.vue?vue&type=script&lang=js&"
import style0 from "./InformHerMasters.vue?vue&type=style&index=0&id=058836b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058836b0",
  null
  
)

export default component.exports